import * as React from 'react';
import {FormComponentProps} from 'antd/lib/form';
import {Form} from 'antd';
import locales from '../locales';
import SubmitCancelFormItem from '../common/form-items/SubmitCancelFormItem';
import InputFormItem from '../common/form-items/InputFormItem';
import furoApi from '../api/FuroApi';
import {ErrorResponse} from '../api/dtos/dtos';
import {ErrorAlert} from '../common/ErrorAlert';

const FIELD_FILE_NAME = "fileName";

interface Props extends FormComponentProps {
  onFormSubmit: (fileName: string) => void;
  onFormCancel: () => void;
}

interface State {
  loading: boolean;
  namingPrefix?: string;
  error?: ErrorResponse;
}

class ToBeTransferredExportForm extends React.Component<Props, State> {
  public state: State = {loading: true};
  private mounted = false;

  public componentDidMount() {
    this.mounted = true;
    furoApi.users.getSelectedCompanyInfo()
      .then(company => {
        if (this.mounted) {
          this.setState({namingPrefix: company.namingPrefix, loading: false});
        }
      })
      .catch((error: ErrorResponse) => {
        if (this.mounted) {
          this.setState({error, loading: false});
        }
      });
  }

  public componentWillUnmount() {
    this.mounted = false;
  }

  public render() {
    const {form} = this.props;
    const {namingPrefix, loading, error} = this.state;
    return (
      <Form>
        <InputFormItem
          form={form}
          fieldId={FIELD_FILE_NAME}
          label={locales.file_name}
          initialValue={loading ? undefined : `${namingPrefix ? namingPrefix + '-' : ''}Utalandó-Tételek`}
          disabled={loading}
          addonAfter=".xls"
          required={true}
        />
        <ErrorAlert error={error}/>
        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel} disabled={loading}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    if (this.state.loading) {
      return;
    }
    const {form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit(values[FIELD_FILE_NAME]);
      }
    });
  };
}

export default Form.create<Props>()(ToBeTransferredExportForm);



// WEBPACK FOOTER //
// ./src/incoming-invoices/ToBeTransferredExportForm.tsx